export default "__VITE_ASSET__BVLfoejd__";